(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csmode-rack"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csmode-rack')) {
  customElements.define('csmode-rack', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = [...this.querySelectorAll('.cs-rack__item')];
      if (!this.items.length) return;
      this.index = 0;
      this.items.forEach((item, i) => {
        item.querySelector('.cs-rack__pick').addEventListener('click', () => this.select(i));
        item.querySelector('.cs-rack__flip')?.addEventListener('click', (event) => {
          const back = item.classList.toggle('is-back');
          event.currentTarget.setAttribute('aria-pressed', String(back));
        });
      });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.select(this.index + Number(button.dataset.step))));
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.items[this.index].querySelector('.cs-rack__pick').focus({preventScroll:true});
        }
      });
      let start;
      this.addEventListener('touchstart', e => { start = [e.touches[0].clientX,e.touches[0].clientY]; }, {passive:true});
      this.addEventListener('touchend', e => {
        if (!start) return;
        const dx = e.changedTouches[0].clientX-start[0], dy = e.changedTouches[0].clientY-start[1];
        if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)) this.select(this.index+(dx<0?1:-1));
        start = null;
      }, {passive:true});
      this.addEventListener('shopify:block:select', e => { const i = this.items.indexOf(e.target.closest('.cs-rack__item')); if(i>=0) this.select(i); });
      this.classList.add('is-ready');
      this.querySelector('.cs-rack__navigation').hidden = this.items.length < 2;
      this.select(0);
    }
    select(index) {
      this.index = (index+this.items.length)%this.items.length;
      this.items.forEach((item,i) => {
        const active = i===this.index;
        item.style.setProperty('--offset', i-this.index);
        item.classList.toggle('is-active',active);
        item.querySelector('.cs-rack__pick').setAttribute('aria-pressed',String(active));
        item.querySelector('.cs-rack__details').inert = !active;
      });
      this.querySelector('.cs-rack__count').textContent = `${String(this.index+1).padStart(2,'0')} / ${String(this.items.length).padStart(2,'0')}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
